export interface ImageSrcSet {
  src: string;
  unit: 'w' | 'px';
  width: number;
}

export const buildImageSrcSet = (imageSrcSet: ImageSrcSet[]) => {
  const sortedImages = imageSrcSet.sort((a, b) => b.width - a.width);
  const srcSet = sortedImages.map(({ src, unit, width }) => `${src} ${width}${unit}`).join(', ');
  return srcSet;
};
